import styles from "./styles.module.scss";

function RefreshinglyFair() {
  return (
    <section className={styles["refreshingly-fair-section"]}>
      <h2 className={styles["fair-heading"]}>Refreshingly fair</h2>
      <div className={styles["fair-items"]}>
        <div className={styles["fair-item"]}>
          <div className={`text:heading-1+ ${styles["fair-title"]}`}>No</div>
          <div className={`text:heading-4 ${styles["fair-subtitle"]}`}>
            Annual fee
          </div>
        </div>
        <div className={styles["fair-item"]}>
          <div className={`text:heading-1 ${styles["fair-title"]}`}>0%</div>
          <div className={`text:heading-4 ${styles["fair-subtitle"]}`}>
            Interest
          </div>
        </div>
        <div className={styles["fair-item"]}>
          <div className={`text:heading-1 ${styles["fair-title"]}`}>No</div>
          <div className={`text:heading-3 ${styles["fair-subtitle"]}`}>
            Credit check
          </div>
        </div>
      </div>
    </section>
  );
}

export default RefreshinglyFair;
